import UndoIcon from '@mui/icons-material/Undo';
import { Box, Button, Card, Typography } from '@mui/material';
import { fr } from 'date-fns/locale/fr';
import React, { useState } from 'react';
import { registerLocale } from 'react-datepicker';
import RefundAskIcon from '../../../../../svg-icons/RefundAskIcon';
import { RefundForm } from './RefundForm.jsx';
registerLocale('fr', fr);

const Refund = ({ ticket, mutateTicket, handleShowComponent, order }) => {
  const sixMonthsAgo = new Date();
  sixMonthsAgo.setMonth(sixMonthsAgo.getMonth() - 6);

  const isOlderThanSixMonths =
    ticket?.order?.dates?.createdAt &&
    new Date(ticket.order.dates.createdAt) < sixMonthsAgo;

  const [hasRIB, setHasRIB] = useState(null);

  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 1,
      }}
    >
      <Card
        elevation={5}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
          width: '100%',
          padding: 2,
        }}
      >
        <Box
          sx={{
            display: 'flex',
            gap: 2,
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <RefundAskIcon fontSize="large" />
          <Typography color="primary">
            <span style={{ fontWeight: 'bold' }}>FORMULAIRE</span> Demander un
            remboursement
          </Typography>
          <Button
            color="primary"
            onClick={() => handleShowComponent(null)}
            variant={'contained'}
            startIcon={<UndoIcon />}
            size="small"
          >
            Retour
          </Button>
        </Box>
      </Card>

      {isOlderThanSixMonths && hasRIB === null && (
        <Card
          elevation={3}
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
            width: '100%',
            padding: 2,
          }}
        >
          <Typography variant="h6">
            Cette commande date de plus de 6 mois. Avez-vous bien le RIB du
            client ?
          </Typography>
          <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2 }}>
            <Button
              variant="contained"
              color="primary"
              onClick={() => setHasRIB(true)}
            >
              Oui
            </Button>
            <Button
              variant="outlined"
              color="info"
              sx={{ fontWeight: 'bold' }}
              onClick={() => handleShowComponent(null)}
            >
              Non
            </Button>
          </Box>
        </Card>
      )}

      {(!isOlderThanSixMonths || hasRIB === true) && (
        <RefundForm
          ticket={ticket}
          isOlderThanSixMonths={isOlderThanSixMonths}
          mutateTicket={mutateTicket}
          handleShowComponent={handleShowComponent}
          order={order}
        />
      )}
    </Box>
  );
};

export default Refund;
